import React, { useEffect } from 'react'
import './style/Impressum.css'
import bio_zertifizierung from '../resources/else/eu_bio_zertifiziert.jpg'

const Impressum = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='impressumContainer'>

      <h1>Impressum</h1>

      <h2>Bio-Zertifizierung</h2>
      <img className='bioZertifikatImg' src={bio_zertifizierung} alt='EU Bio Zertifizierung (AT-BIO-401)' />
      <p>
        <strong>Bio-Kontrollstelle:</strong> AT-BIO-401 <br />
        BIOS - Biokontrollservice Österreich <br />
        EU/Nicht-EU-Landwirtschaft
      </p>

      <h2>Informationen und Offenlegungspflichten</h2>
      <p>
        Informationspflicht laut §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch, 
        §63 Gewerbeordnung und Offenlegungspflicht laut §25 Mediengesetz.
      </p>

      <p>
        <strong>Kaffeebrennerei - Peter Zwingler</strong> <br />
        Innviertlerstraße 19 <br />
        4911 Tumeltsham <br />
        Österreich
      </p>

      <p>
        <strong>Unternehmensgegenstand:</strong> Handelsgewerbe mit Ausnahme der reglementierten Handelsgewerbe und Handelsagent (Einzelhandel mit Lebensmitteln)<br />
        <strong>UID-Nummer:</strong> ATU62191149 <br />
        <strong>GISA-Zahl:</strong> 31114509 <br />
        <strong>GLN:</strong> 9110010453152
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: +43 676/ 7700272 <br />
        E-Mail:{' '}
        <a href='mailto:office@kaffeebrennerei.at'>office@kaffeebrennerei.at</a>
      </p>

      <h2>Kammerzugehörigkeit & Aufsichtsbehörde</h2>
      <p>
        <strong>Mitglied bei:</strong> WKO Oberösterreich, Landesgremium Lebensmittelhandel (Berufszweig: Einzelhandel mit Lebensmitteln) <br />
        <strong>Berufsrecht:</strong> Gewerbeordnung: <a href="https://www.ris.bka.gv.at" target="_blank" rel="noreferrer">www.ris.bka.gv.at</a> <br />
        <strong>Aufsichtsbehörde/Gewerbebehörde:</strong> Bezirkshauptmannschaft Ried im Innkreis
      </p>

      <h2>Angaben zur Online-Streitbeilegung</h2>
      <p>
        Verbraucher haben die Möglichkeit, Beschwerden an die Online-Streitbeilegungsplattform der EU zu richten: 
        <a href="http://ec.europa.eu/odr" target="_blank" rel="noreferrer"> http://ec.europa.eu/odr</a>. 
        Sie können allfällige Beschwerde auch an die oben angegebene E-Mail-Adresse richten.
      </p>

      <h2>Haftungsausschluss</h2>

      <h3>Haftung für Inhalte dieser Website</h3>
      <p>
        Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns um korrekte und aktuelle Informationen. 
        Leider können wir keine Haftung für die Korrektheit aller Inhalte auf dieser Webseite übernehmen, speziell für jene 
        die seitens Dritter bereitgestellt wurden. Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, 
        bitten wir Sie uns umgehend zu kontaktieren.
      </p>

      <h3>Haftung für Links auf dieser Website</h3>
      <p>
        Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir nicht verantwortlich sind. 
        Haftung für verlinkte Websites besteht laut § 17 ECG für uns nicht, da wir keine Kenntnis rechtswidriger 
        Tätigkeiten hatten und haben, uns solche Rechtsverletzungen auch bisher nicht aufgefallen sind und wir 
        Links sofort entfernen würden, wenn uns Rechtsverletzungen bekannt werden.
      </p>

      <h3>Urheberrechtshinweis</h3>
      <p>
        Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem österreichischen Urheberrecht. 
        Bitte fragen Sie uns bevor Sie die Inhalte dieser Website verbreiten, vervielfältigen oder verwerten 
        wie zum Beispiel auf anderen Websites erneut veröffentlichen. Falls notwendig, werden wir die unerlaubte 
        Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen.
      </p>
    </div>
  )
}

export default Impressum